/*
 * Copyright (c) 2022, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export default makeStyles((theme: Theme) =>
  createStyles({
    anonymousBannerTooltipTextContainer: {
      paddingTop: theme.spacing(1.5),
      paddingLeft: theme.spacing(0.875),
      paddingBottom: theme.spacing(0.375),
    },
    anonymousBannerTooltipText: {
      paddingBottom: theme.spacing(1.75),
    },
    anonymousBannerTooltipHorizontalLine: {
      height: theme.spacing(0.125),
      width: theme.spacing(34),
      opacity: 0.59,
      backgroundColor: '#E1E2E7',
    },
    anonymousBannerTooltipLinkTextContainer: {
      paddingTop: theme.spacing(0.625),
    },
    anonymousBannerTooltipLinkText: {
      color: '#5567D5',
      '&:hover,&:focus': {
        color: '#5567D5',
      },
    },
    anonymousBtn: {
      color: '#5567D5',
      backgroundColor: theme.palette.common.white,
      height: 40,
      width: 248,
      borderRadius: 5,
      paddingRight: 8,
      paddingLeft: 8,
    },
    anonymousDivider: {
      marginLeft: theme.spacing(2),
      marginRight: theme.spacing(2),
      marginTop: theme.spacing(1.75),
      marginBottom: theme.spacing(1.75),
      width: theme.spacing(27),
      height: theme.spacing(0.25),
    },
  })
);
